import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const VACIO = { emoji: "", titulo: "" };

const AdminOpcionesExtras = () => {
  const navigate = useNavigate();
  const [filas, setFilas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [editando, setEditando] = useState(null); // id | "nuevo" | null
  const [form, setForm] = useState(VACIO);
  const [guardando, setGuardando] = useState(false);

  const cargar = async () => {
    setLoading(true);
    try {
      const res = await axios.get("/api/servicio/opciones_extras");
      setFilas(res.data || []);
      setError("");
    } catch {
      setError("❌ Error al cargar opciones.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { cargar(); }, []);

  const abrirNuevo = () => { setForm(VACIO); setEditando("nuevo"); };
  const abrirEditar = (fila) => {
    setForm({ emoji: fila.emoji || "", titulo: fila.titulo });
    setEditando(fila.id);
  };
  const cancelar = () => { setEditando(null); setForm(VACIO); };

  const guardar = async () => {
    if (!form.titulo.trim()) { setError("El título es obligatorio."); return; }
    setGuardando(true);
    setError("");
    try {
      if (editando === "nuevo") {
        await axios.post("/api/servicio/opciones_extras", form);
      } else {
        await axios.put(`/api/servicio/opciones_extras/${editando}`, form);
      }
      await cargar();
      cancelar();
    } catch (e) {
      setError(e.response?.data?.error || "❌ Error al guardar.");
    } finally {
      setGuardando(false);
    }
  };

  const eliminar = async (id) => {
    if (!window.confirm("¿Eliminar esta opción?")) return;
    try {
      await axios.delete(`/api/servicio/opciones_extras/${id}`);
      setFilas((f) => f.filter((r) => r.id !== id));
    } catch {
      setError("❌ Error al eliminar.");
    }
  };

  return (
    <div style={{ minHeight: "100vh", background: "#f0f4f8", padding: "24px 16px" }}>
      <div style={{ maxWidth: 700, margin: "0 auto" }}>
        <button
          onClick={() => navigate(-1)}
          style={{ background: "none", border: "none", cursor: "pointer", fontSize: 15, color: "#3b82f6", fontWeight: 700, marginBottom: 20, padding: 0 }}
        >
          ← Volver
        </button>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
          <h2 style={{ fontSize: 22, fontWeight: 800, color: "#1e3a5f", margin: 0 }}>⭐ Opciones extras</h2>
          {editando === null && (
            <button
              onClick={abrirNuevo}
              style={{ background: "#3b82f6", color: "#fff", border: "none", borderRadius: 10, padding: "10px 18px", fontWeight: 700, cursor: "pointer", fontSize: 15 }}
            >
              + Añadir
            </button>
          )}
        </div>

        <div style={{ background: "#eff6ff", border: "1.5px solid #bfdbfe", borderRadius: 12, padding: "12px 16px", marginBottom: 20, fontSize: 14, color: "#1e40af" }}>
          Estas opciones aparecen en el botón "Añadir extra" dentro de la ejecución del piso para la asistenta.
        </div>

        {error && <div style={{ background: "#fee2e2", color: "#b91c1c", borderRadius: 10, padding: "10px 14px", marginBottom: 16 }}>{error}</div>}

        {editando !== null && (
          <div style={{ background: "#fff", border: "2px solid #3b82f6", borderRadius: 14, padding: 20, marginBottom: 24, boxShadow: "0 2px 8px rgba(0,0,0,0.08)" }}>
            <div style={{ fontSize: 16, fontWeight: 700, color: "#1e3a5f", marginBottom: 16 }}>
              {editando === "nuevo" ? "Nueva opción extra" : "Editar opción extra"}
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              <div>
                <label style={{ fontSize: 13, fontWeight: 600, color: "#475569", display: "block", marginBottom: 4 }}>Emoji</label>
                <input
                  type="text"
                  value={form.emoji}
                  onChange={(e) => setForm((f) => ({ ...f, emoji: e.target.value }))}
                  placeholder="Ej: ⭐"
                  style={{ width: 80, padding: "10px 12px", borderRadius: 8, border: "1.5px solid #cbd5e1", fontSize: 20, textAlign: "center" }}
                />
              </div>
              <div>
                <label style={{ fontSize: 13, fontWeight: 600, color: "#475569", display: "block", marginBottom: 4 }}>Título *</label>
                <input
                  type="text"
                  value={form.titulo}
                  onChange={(e) => setForm((f) => ({ ...f, titulo: e.target.value }))}
                  placeholder="Ej: Limpieza de terraza"
                  style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1.5px solid #cbd5e1", fontSize: 15, boxSizing: "border-box" }}
                />
              </div>
            </div>
            <div style={{ display: "flex", gap: 10, marginTop: 16 }}>
              <button
                onClick={guardar}
                disabled={guardando}
                style={{ background: "#3b82f6", color: "#fff", border: "none", borderRadius: 8, padding: "10px 20px", fontWeight: 700, cursor: "pointer", fontSize: 14 }}
              >
                {guardando ? "Guardando..." : "Guardar"}
              </button>
              <button
                onClick={cancelar}
                style={{ background: "#e2e8f0", color: "#475569", border: "none", borderRadius: 8, padding: "10px 16px", fontWeight: 600, cursor: "pointer", fontSize: 14 }}
              >
                Cancelar
              </button>
            </div>
          </div>
        )}

        {loading ? (
          <div style={{ textAlign: "center", color: "#64748b", padding: 40 }}>Cargando...</div>
        ) : filas.length === 0 ? (
          <div style={{ background: "#fff", borderRadius: 14, padding: 32, textAlign: "center", color: "#94a3b8" }}>
            No hay opciones todavía. Pulsa "+ Añadir" para crear la primera.
          </div>
        ) : (
          <div style={{ background: "#fff", borderRadius: 14, boxShadow: "0 2px 6px rgba(0,0,0,0.06)", overflow: "hidden" }}>
            {filas.map((fila, idx) => (
              <div
                key={fila.id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "14px 18px",
                  borderBottom: idx < filas.length - 1 ? "1px solid #f1f5f9" : "none",
                  gap: 14,
                }}
              >
                <span style={{ fontSize: 28, minWidth: 36, textAlign: "center" }}>{fila.emoji || "⭐"}</span>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 16, fontWeight: 700, color: "#1e3a5f" }}>{fila.titulo}</div>
                </div>
                <button
                  onClick={() => abrirEditar(fila)}
                  style={{ background: "#eff6ff", border: "1.5px solid #bfdbfe", borderRadius: 8, padding: "7px 14px", cursor: "pointer", color: "#3b82f6", fontWeight: 600, fontSize: 13 }}
                >
                  ✏️ Editar
                </button>
                <button
                  onClick={() => eliminar(fila.id)}
                  style={{ background: "#fff1f2", border: "1.5px solid #fca5a5", borderRadius: 8, padding: "7px 14px", cursor: "pointer", color: "#dc2626", fontWeight: 600, fontSize: 13 }}
                >
                  🗑 Borrar
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminOpcionesExtras;
